import axios from 'axios'
import { logger } from '@/logger'
import { EventBus, Events } from '@/eventbus/EventBus'

function handleError(error, reject) {
  if (error.response) {
    // Prevent 401s from polluting the logging
    if (error.response && error.response.status !== 401) {
      logger.error(
        `[${error.response.status}] ${JSON.stringify(error.response.data)}`
      )
    }
  } else if (error.request) {
    logger.error(error.request)
  } else {
    logger.error(error.message || error)
  }
  reject(error.response)
}

function executeGet(url) {
  return new Promise((resolve, reject) => {
    axios
      .get(url)
      .then((response) => resolve(response.data))
      .catch((error) => handleError(error, reject))
  })
}

function executeDelete(url) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url)
      .then((response) => resolve(response.data))
      .catch((error) => handleError(error, reject))
  })
}

function executePost(url, payload) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, payload)
      .then((response) => {
        if (response.data.error) {
          reject(response.data.error)
        } else {
          resolve(response.data)
        }
      })
      .catch((error) => handleError(error, reject))
  })
}

function executePut(url, payload) {
  return new Promise((resolve, reject) => {
    axios
      .put(url, payload)
      .then((response) => {
        if (response.data.error) {
          reject(response.data.error)
        } else {
          resolve(response.data)
        }
      })
      .catch((error) => handleError(error, reject))
  })
}

function getArray(url) {
  return new Promise((resolve, reject) => {
    axios
      .get(url)
      .then((response) => {
        if (response.data && response.data instanceof Array) {
          resolve(response.data)
        } else {
          resolve([])
        }
      })
      .catch((error) => {
        logger.error(error)
        reject()
      })
  })
}

function post(url, payload) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, payload)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        logger.error(error)
        reject()
      })
  })
}

function get(url) {
  return new Promise((resolve, reject) => {
    axios
      .get(url)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        logger.error(error)
        reject()
      })
  })
}

function patch(url, payload) {
  return new Promise((resolve, reject) => {
    axios
      .patch(url, payload)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        logger.error(error)
        reject()
      })
  })
}

function httpDelete(url, payload) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, { data: payload })
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        logger.error(error)
        reject()
      })
  })
}

export {
  executeGet,
  executePost,
  executeDelete,
  executePut,
  getArray,
  post,
  get,
  patch,
  httpDelete
}
